import * as i0 from '@angular/core';
import { Component, Input, Injectable, NgModule, EventEmitter, Output, ViewChild, Directive, HostListener, HostBinding, Self, ContentChildren, NgZone } from '@angular/core';
import { Overlay, OverlayModule } from '@angular/cdk/overlay';
import { ComponentPortal, PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { CdkTableModule } from '@angular/cdk/table';
import { A11yModule } from '@angular/cdk/a11y';
import { BidiModule } from '@angular/cdk/bidi';
import { ObserversModule } from '@angular/cdk/observers';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { PlatformModule } from '@angular/cdk/platform';
import { HttpClientModule } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { __awaiter } from 'tslib';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { ReactiveFormsModule } from '@angular/forms';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/cdk/overlay';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/platform-browser';
import * as ɵngcc4 from '@angular/forms';

const _c0 = ["MainModal"];
const _c1 = function (a0, a1) { return { "show": a0, "fade": a1 }; };
function ModalComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1, 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵelementStart(5, "div");
    ɵngcc0.ɵɵelementStart(6, "h5", 6);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "button", 7);
    ɵngcc0.ɵɵlistener("click", function ModalComponent_div_0_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.closeModal(); });
    ɵngcc0.ɵɵelementStart(9, "span", 8);
    ɵngcc0.ɵɵtext(10, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 9);
    ɵngcc0.ɵɵprojection(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(5, _c1, ctx_r0.show, ctx_r0.show));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵclassMapInterpolate1("modal-header ", ctx_r0.classHeader, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.title, " ");
} }
const _c2 = ["*"];
function FileUploadComponent_ngx_dropzone_image_preview_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngx-dropzone-image-preview", 3);
    ɵngcc0.ɵɵlistener("removed", function FileUploadComponent_ngx_dropzone_image_preview_5_Template_ngx_dropzone_image_preview_removed_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const file_r2 = ctx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onRemove(file_r2); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("file", file_r2)("removable", true);
} }
function FileUploadComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "p", 5);
    ɵngcc0.ɵɵtext(2, "<---------- Deslize para ver todos os arquivos ---------->");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function NgxDropzonePreviewComponent_ngx_dropzone_remove_badge_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngx-dropzone-remove-badge", 1);
    ɵngcc0.ɵɵlistener("click", function NgxDropzonePreviewComponent_ngx_dropzone_remove_badge_1_Template_ngx_dropzone_remove_badge_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1._remove($event); });
    ɵngcc0.ɵɵelementEnd();
} }
const _c3 = [[["ngx-dropzone-label"]]];
const _c4 = ["ngx-dropzone-label"];
const _c5 = ["fileInput"];
function NgxDropzoneComponent_ng_content_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 2, ["*ngIf", "!_hasPreviews"]);
} }
const _c6 = [[["ngx-dropzone-preview"]], "*", [["ngx-dropzone-label"]]];
const _c7 = ["ngx-dropzone-preview", "*", "ngx-dropzone-label"];
function NgxDropzoneImagePreviewComponent_img_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r0.imageSrc, ɵngcc0.ɵɵsanitizeUrl);
} }
function NgxDropzoneImagePreviewComponent_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 5);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r1.imageSrc, ɵngcc0.ɵɵsanitizeUrl);
} }
function NgxDropzoneImagePreviewComponent_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.file == null ? null : ctx_r2.file.name);
} }
function NgxDropzoneImagePreviewComponent_ngx_dropzone_remove_badge_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngx-dropzone-remove-badge", 6);
    ɵngcc0.ɵɵlistener("click", function NgxDropzoneImagePreviewComponent_ngx_dropzone_remove_badge_4_Template_ngx_dropzone_remove_badge_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4._remove($event); });
    ɵngcc0.ɵɵelementEnd();
} }
function NgxDropzoneVideoPreviewComponent_video_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "video", 2);
    ɵngcc0.ɵɵlistener("click", function NgxDropzoneVideoPreviewComponent_video_0_Template_video_click_0_listener($event) { return $event.stopPropagation(); });
    ɵngcc0.ɵɵelement(1, "source", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r0.sanitizedVideoSrc, ɵngcc0.ɵɵsanitizeUrl);
} }
function NgxDropzoneVideoPreviewComponent_ngx_dropzone_remove_badge_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngx-dropzone-remove-badge", 4);
    ɵngcc0.ɵɵlistener("click", function NgxDropzoneVideoPreviewComponent_ngx_dropzone_remove_badge_2_Template_ngx_dropzone_remove_badge_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3._remove($event); });
    ɵngcc0.ɵɵelementEnd();
} }
const _c8 = ["circle"];
function InputPasswordComponent_input_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 6);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("id", ctx_r0.formControlName || "password");
    ɵngcc0.ɵɵproperty("formControl", ctx_r0.control)("placeholder", ctx_r0.placeholder)("ngStyle", ctx_r0.style)("maxlength", ctx_r0.maxlength);
} }
function InputPasswordComponent_input_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 7);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("id", ctx_r1.formControlName || "password");
    ɵngcc0.ɵɵproperty("formControl", ctx_r1.control)("placeholder", ctx_r1.placeholder)("ngStyle", ctx_r1.style)("maxlength", ctx_r1.maxlength);
} }
class LoaderComponent {
    constructor() {
        this.message = 'Carregando...';
        this.showLoader = false;
    }
    ngOnInit() {
    }
}
LoaderComponent.ɵfac = function LoaderComponent_Factory(t) { return new (t || LoaderComponent)(); };
LoaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LoaderComponent, selectors: [["dharma-loader"]], inputs: { showLoader: "showLoader" }, decls: 6, vars: 1, consts: [[1, "loading", "show"], [1, "wrapper"], [1, "img"], ["alt", "Dotz - Sua moeda para a vida render mais", "src", "./assets/images/ball-1.png"]], template: function LoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "img", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "h2");
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.message);
    } }, styles: ["div.loading.show[_ngcontent-%COMP%]{z-index:1000000;background-color:hsla(0,0%,100%,.7)}div.loading[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{position:absolute;left:50%;top:55%;transform:translate(-50%,-50%);color:#244788;text-align:center}div.loading[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{margin-top:20px;padding:15px;font-size:16px;font-family:Hurme Bold}@-webkit-keyframes scaleText{0%,53%{transform:scaleY(0);-webkit-transform:scaleY(0);-moz-transform:scaleY(0);-ms-transform:scaleY(0);-o-transform:scaleY(0)}67%,to{transform:scaleY(1);-webkit-transform:scaleY(1);-moz-transform:scaleY(1);-ms-transform:scaleY(1);-o-transform:scaleY(1)}}@keyframes scaleText{0%,53%{transform:scaleY(0);-webkit-transform:scaleY(0);-moz-transform:scaleY(0);-ms-transform:scaleY(0);-o-transform:scaleY(0)}67%,to{transform:scaleY(1);-webkit-transform:scaleY(1);-moz-transform:scaleY(1);-ms-transform:scaleY(1);-o-transform:scaleY(1)}}@-webkit-keyframes shadow{0%,55%{opacity:0}65%,to{opacity:1}}@keyframes shadow{0%,55%{opacity:0}65%,to{opacity:1}}@-webkit-keyframes moveBall{0%{top:-50px;right:0;transform:rotate(0);-webkit-transform:rotate(0);-moz-transform:rotate(0);-ms-transform:rotate(0);-o-transform:rotate(0)}10%,30%{top:0}20%{top:-25px}40%{top:-10px}50%{top:0;right:41%;transform:rotate(-1turn);-webkit-transform:rotate(-1turn);-moz-transform:rotate(-1turn);-ms-transform:rotate(-1turn);-o-transform:rotate(-1turn)}80%,90%,to{top:-45px;right:45%;transform:rotate(-340deg);-webkit-transform:rotate(-340deg);-moz-transform:rotate(-340deg);-ms-transform:rotate(-340deg);-o-transform:rotate(-340deg)}}@keyframes moveBall{0%{top:-50px;right:0;transform:rotate(0);-webkit-transform:rotate(0);-moz-transform:rotate(0);-ms-transform:rotate(0);-o-transform:rotate(0)}10%,30%{top:0}20%{top:-25px}40%{top:-10px}50%{top:0;right:41%;transform:rotate(-1turn);-webkit-transform:rotate(-1turn);-moz-transform:rotate(-1turn);-ms-transform:rotate(-1turn);-o-transform:rotate(-1turn)}80%,90%,to{top:-45px;right:45%;transform:rotate(-340deg);-webkit-transform:rotate(-340deg);-moz-transform:rotate(-340deg);-ms-transform:rotate(-340deg);-o-transform:rotate(-340deg)}}div.loading[_ngcontent-%COMP%]{display:none}div.loading.show[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:999;background-color:hsla(0,0%,100%,.8);display:flex;justify-content:center;align-items:center}div.loading.show[_ngcontent-%COMP%]   div.wrapper[_ngcontent-%COMP%]{width:100%;max-width:600px;height:250px;position:relative;overflow:hidden;display:flex;flex-flow:row wrap;justify-content:flex-end}div.loading.show[_ngcontent-%COMP%]   div.wrapper[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{text-align:center;font-family:Hurme Bold,Arial,Helvetica,sans-serif;font-size:1.6em;color:#f7941d;position:relative;top:0;flex-basis:100%}div.loading.show[_ngcontent-%COMP%]   div.wrapper[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:after{content:\"\";width:165px;height:0;position:absolute;left:35%;top:50px;box-shadow:5px 5px 10px 1px #666;-o-box-shadow:5px 5px 10px 1px #666;-ms-box-shadow:5px 5px 10px 1px #666;-moz-box-shadow:5px 5px 10px 1px #666;-webkit-box-shadow:5px 5px 10px 1px #666;-webkit-animation-name:shadow;animation-name:shadow;-webkit-animation-duration:3s;animation-duration:3s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}div.loading.show[_ngcontent-%COMP%]   div.wrapper[_ngcontent-%COMP%]   div.img[_ngcontent-%COMP%]{max-width:100px;position:relative;top:-150px;right:-90px;align-self:flex-end;-webkit-animation-name:moveBall;animation-name:moveBall;-webkit-animation-duration:3s;animation-duration:3s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}div.loading.show[_ngcontent-%COMP%]   div.wrapper[_ngcontent-%COMP%]   div.img[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:100px}"] });
LoaderComponent.ctorParameters = () => [];
LoaderComponent.propDecorators = {
    showLoader: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoaderComponent, [{
        type: Component,
        args: [{
                selector: 'dharma-loader',
                template: "<div class=\"loading show\">\n    <div class=\"wrapper\">\n        <div class=\"img\"><img alt=\"Dotz - Sua moeda para a vida render mais\" src=\"./assets/images/ball-1.png\"></div>\n        <h2>{{ message }}</h2>\n    </div>\n</div>",
                styles: ["div.loading.show{z-index:1000000;background-color:hsla(0,0%,100%,.7)}div.loading .content{position:absolute;left:50%;top:55%;transform:translate(-50%,-50%);color:#244788;text-align:center}div.loading .content .message{margin-top:20px;padding:15px;font-size:16px;font-family:Hurme Bold}@-webkit-keyframes scaleText{0%,53%{transform:scaleY(0);-webkit-transform:scaleY(0);-moz-transform:scaleY(0);-ms-transform:scaleY(0);-o-transform:scaleY(0)}67%,to{transform:scaleY(1);-webkit-transform:scaleY(1);-moz-transform:scaleY(1);-ms-transform:scaleY(1);-o-transform:scaleY(1)}}@keyframes scaleText{0%,53%{transform:scaleY(0);-webkit-transform:scaleY(0);-moz-transform:scaleY(0);-ms-transform:scaleY(0);-o-transform:scaleY(0)}67%,to{transform:scaleY(1);-webkit-transform:scaleY(1);-moz-transform:scaleY(1);-ms-transform:scaleY(1);-o-transform:scaleY(1)}}@-webkit-keyframes shadow{0%,55%{opacity:0}65%,to{opacity:1}}@keyframes shadow{0%,55%{opacity:0}65%,to{opacity:1}}@-webkit-keyframes moveBall{0%{top:-50px;right:0;transform:rotate(0);-webkit-transform:rotate(0);-moz-transform:rotate(0);-ms-transform:rotate(0);-o-transform:rotate(0)}10%,30%{top:0}20%{top:-25px}40%{top:-10px}50%{top:0;right:41%;transform:rotate(-1turn);-webkit-transform:rotate(-1turn);-moz-transform:rotate(-1turn);-ms-transform:rotate(-1turn);-o-transform:rotate(-1turn)}80%,90%,to{top:-45px;right:45%;transform:rotate(-340deg);-webkit-transform:rotate(-340deg);-moz-transform:rotate(-340deg);-ms-transform:rotate(-340deg);-o-transform:rotate(-340deg)}}@keyframes moveBall{0%{top:-50px;right:0;transform:rotate(0);-webkit-transform:rotate(0);-moz-transform:rotate(0);-ms-transform:rotate(0);-o-transform:rotate(0)}10%,30%{top:0}20%{top:-25px}40%{top:-10px}50%{top:0;right:41%;transform:rotate(-1turn);-webkit-transform:rotate(-1turn);-moz-transform:rotate(-1turn);-ms-transform:rotate(-1turn);-o-transform:rotate(-1turn)}80%,90%,to{top:-45px;right:45%;transform:rotate(-340deg);-webkit-transform:rotate(-340deg);-moz-transform:rotate(-340deg);-ms-transform:rotate(-340deg);-o-transform:rotate(-340deg)}}div.loading{display:none}div.loading.show{position:fixed;top:0;left:0;width:100%;height:100%;z-index:999;background-color:hsla(0,0%,100%,.8);display:flex;justify-content:center;align-items:center}div.loading.show div.wrapper{width:100%;max-width:600px;height:250px;position:relative;overflow:hidden;display:flex;flex-flow:row wrap;justify-content:flex-end}div.loading.show div.wrapper h2{text-align:center;font-family:Hurme Bold,Arial,Helvetica,sans-serif;font-size:1.6em;color:#f7941d;position:relative;top:0;flex-basis:100%}div.loading.show div.wrapper h2 :after{content:\"\";width:165px;height:0;position:absolute;left:35%;top:50px;box-shadow:5px 5px 10px 1px #666;-o-box-shadow:5px 5px 10px 1px #666;-ms-box-shadow:5px 5px 10px 1px #666;-moz-box-shadow:5px 5px 10px 1px #666;-webkit-box-shadow:5px 5px 10px 1px #666;-webkit-animation-name:shadow;animation-name:shadow;-webkit-animation-duration:3s;animation-duration:3s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}div.loading.show div.wrapper div.img{max-width:100px;position:relative;top:-150px;right:-90px;align-self:flex-end;-webkit-animation-name:moveBall;animation-name:moveBall;-webkit-animation-duration:3s;animation-duration:3s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}div.loading.show div.wrapper div.img img{max-width:100px}"]
            }]
    }], function () { return []; }, { showLoader: [{
            type: Input
        }] }); })();

class LoaderService {
    constructor(_overlay) {
        this._overlay = _overlay;
    }
    /**
     * @description Mostrar loader
     * @example this.loaderService.show();
     */
    show() {
        if (this.overlayRef) {
            return;
        }
        const positionStrategy = this._overlay
            .position()
            .global()
            .centerVertically()
            .centerHorizontally();
        const overlayRef = this._overlay.create({
            hasBackdrop: true,
            positionStrategy,
        });
        const portal = new ComponentPortal(LoaderComponent);
        overlayRef.backdropClick().subscribe(() => overlayRef.detach());
        this.componentRef = overlayRef.attach(portal);
        this.overlayRef = overlayRef;
    }
    /**
     * @description Ocultar loader
     * @example this.loaderService.hide();
     */
    hide() {
        try {
            this.componentRef.destroy();
            this.overlayRef.detach();
            this.overlayRef.dispose();
            this.overlayRef.close();
        }
        catch (err) { }
        this.overlayRef = null;
    }
}
LoaderService.ɵfac = function LoaderService_Factory(t) { return new (t || LoaderService)(ɵngcc0.ɵɵinject(ɵngcc1.Overlay)); };
LoaderService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LoaderService, factory: LoaderService.ɵfac });
LoaderService.ctorParameters = () => [
    { type: Overlay }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoaderService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Overlay }]; }, null); })();

class LoaderModule {
}
LoaderModule.ɵfac = function LoaderModule_Factory(t) { return new (t || LoaderModule)(); };
LoaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LoaderModule });
LoaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [LoaderService], imports: [[
            CommonModule,
            CdkTableModule,
            A11yModule,
            BidiModule,
            OverlayModule,
            PlatformModule,
            ObserversModule,
            PortalModule,
            CdkStepperModule,
            PlatformModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LoaderModule, { declarations: function () { return [LoaderComponent]; }, imports: function () { return [CommonModule,
        CdkTableModule,
        A11yModule,
        BidiModule,
        OverlayModule,
        PlatformModule,
        ObserversModule,
        PortalModule,
        CdkStepperModule,
        PlatformModule]; }, exports: function () { return [LoaderComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoaderModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    LoaderComponent
                ],
                entryComponents: [LoaderComponent],
                imports: [
                    CommonModule,
                    CdkTableModule,
                    A11yModule,
                    BidiModule,
                    OverlayModule,
                    PlatformModule,
                    ObserversModule,
                    PortalModule,
                    CdkStepperModule,
                    PlatformModule
                ],
                providers: [LoaderService],
                exports: [LoaderComponent]
            }]
    }], null, null); })();

class ModalComponent {
    constructor() {
        this.title = '';
        this.type = '';
        this.classHeader = '';
        this.show = false;
        this.hideBtn = false;
        this.closeAction = new EventEmitter();
        this.cancelAction = new EventEmitter();
        this.confirmAction = new EventEmitter();
        this.defaultAction = new EventEmitter();
    }
    ngOnInit() {
    }
    ngOnChanges() {
        if (this.show == true) {
            document.querySelector('body').classList.add('modal-open');
        }
        if (this.show == false) {
            document.querySelector('body').classList.remove('modal-open');
        }
    }
    closeModal() {
        this.closeAction.emit('close');
    }
    actionCancel() {
        this.cancelAction.emit('cancel');
    }
    actionConfirm() {
        this.confirmAction.emit('confirm');
    }
    actionDefault() {
        this.defaultAction.emit('default');
    }
}
ModalComponent.ɵfac = function ModalComponent_Factory(t) { return new (t || ModalComponent)(); };
ModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ModalComponent, selectors: [["dharma-modal"]], viewQuery: function ModalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.MainModal = _t.first);
    } }, inputs: { title: "title", type: "type", classHeader: "classHeader", show: "show", hideBtn: "hideBtn" }, outputs: { closeAction: "closeAction", cancelAction: "cancelAction", confirmAction: "confirmAction", defaultAction: "defaultAction" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2, decls: 1, vars: 1, consts: [["id", "dharma-components-ui-modal", "class", "modal", 3, "ngClass", 4, "ngIf"], ["id", "dharma-components-ui-modal", 1, "modal", 3, "ngClass"], ["MainModal", ""], [1, "main-modal"], [1, "modal-dialog", "modal-dialog-centered"], [1, "modal-content"], ["id", "exampleModalLongTitle", 1, "modal-title", "text-center", "gen-tituloCard", "tituloCardAberto"], ["type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"]], template: function ModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, ModalComponent_div_0_Template, 13, 8, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.show);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgClass], styles: ["div#dharma-components-ui-modal[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);z-index:9999;display:block}div#dharma-components-ui-modal[_ngcontent-%COMP%]   .main-modal[_ngcontent-%COMP%]{margin:auto}div#dharma-components-ui-modal[_ngcontent-%COMP%]   .main-modal[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{max-width:600px}div#dharma-components-ui-modal[_ngcontent-%COMP%]   .main-modal[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{border-radius:5px;-webkit-border-radius:5px;-moz-border-radius:5px;-ms-border-radius:5px;position:static}div#dharma-components-ui-modal[_ngcontent-%COMP%]   .main-modal[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{position:absolute;right:0;margin-top:-40px;border:3px solid #fff;background:#2f353a;color:#fff;font-size:2em;border-radius:30px;-webkit-border-radius:30px;-moz-border-radius:30px;-ms-border-radius:30px;height:50px;width:50px;padding:0}div#dharma-components-ui-modal[_ngcontent-%COMP%]   .main-modal[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]   .iconAlertModal[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:before{color:#fddc01!important}.modal-body[_ngcontent-%COMP%]{padding:1.5rem}"] });
ModalComponent.ctorParameters = () => [];
ModalComponent.propDecorators = {
    title: [{ type: Input }],
    type: [{ type: Input }],
    classHeader: [{ type: Input }],
    show: [{ type: Input }],
    hideBtn: [{ type: Input }],
    closeAction: [{ type: Output }],
    cancelAction: [{ type: Output }],
    confirmAction: [{ type: Output }],
    defaultAction: [{ type: Output }],
    MainModal: [{ type: ViewChild, args: ['MainModal', { static: false },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalComponent, [{
        type: Component,
        args: [{
                selector: 'dharma-modal',
                template: "<div id=\"dharma-components-ui-modal\" class=\"modal\" [ngClass]=\"{'show': show, 'fade':show}\" *ngIf=\"show\" #MainModal>\n\t<div class=\"main-modal\">\n\t\t<div class=\"modal-dialog modal-dialog-centered\">\n\t\t\t<div class=\"modal-content\">\n\t\t\t\t<div class=\"modal-header {{ classHeader }}\">\n\t\t\t\t\t<h5 class=\"modal-title text-center gen-tituloCard  tituloCardAberto\"\n\t\t\t\t\t\tid=\"exampleModalLongTitle\">\n\t\t\t\t\t\t{{ title }}\n\t\t\t\t\t</h5>\n\t\t\t\t\t<button type=\"button\" class=\"close\" (click)=\"closeModal()\"\n\t\t\t\t\t\taria-label=\"Close\">\n\t\t\t\t\t\t<span aria-hidden=\"true\">&times;</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"modal-body\">\n\t\t\t\t\t<ng-content></ng-content>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>",
                styles: ["div#dharma-components-ui-modal{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.7);z-index:9999;display:block}div#dharma-components-ui-modal .main-modal{margin:auto}div#dharma-components-ui-modal .main-modal .modal-dialog{max-width:600px}div#dharma-components-ui-modal .main-modal .modal-content{border-radius:5px;-webkit-border-radius:5px;-moz-border-radius:5px;-ms-border-radius:5px;position:static}div#dharma-components-ui-modal .main-modal .modal-content .close{position:absolute;right:0;margin-top:-40px;border:3px solid #fff;background:#2f353a;color:#fff;font-size:2em;border-radius:30px;-webkit-border-radius:30px;-moz-border-radius:30px;-ms-border-radius:30px;height:50px;width:50px;padding:0}div#dharma-components-ui-modal .main-modal .modal-content .iconAlertModal span:before{color:#fddc01!important}.modal-body{padding:1.5rem}"]
            }]
    }], function () { return []; }, { title: [{
            type: Input
        }], type: [{
            type: Input
        }], classHeader: [{
            type: Input
        }], show: [{
            type: Input
        }], hideBtn: [{
            type: Input
        }], closeAction: [{
            type: Output
        }], cancelAction: [{
            type: Output
        }], confirmAction: [{
            type: Output
        }], defaultAction: [{
            type: Output
        }], MainModal: [{
            type: ViewChild,
            args: ['MainModal', { static: false }]
        }] }); })();

class ModalModule {
}
ModalModule.ɵfac = function ModalModule_Factory(t) { return new (t || ModalModule)(); };
ModalModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ModalModule, bootstrap: function () { return [ModalComponent]; } });
ModalModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            HttpClientModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ModalModule, { declarations: function () { return [ModalComponent]; }, imports: function () { return [CommonModule,
        HttpClientModule]; }, exports: function () { return [ModalComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ModalComponent
                ],
                imports: [
                    CommonModule,
                    HttpClientModule,
                ],
                bootstrap: [ModalComponent],
                exports: [ModalComponent]
            }]
    }], null, null); })();

class FileUploadService {
    constructor() {
        this.fileUpload = new BehaviorSubject('init');
        this.fileUploadAsync = this.fileUpload.asObservable();
    }
    /**
     * @description Limpar lista de arquivos
     * @example this.fileUploadService.clear();
     */
    clear() {
        this.fileUpload.next('clear');
    }
}
FileUploadService.ɵfac = function FileUploadService_Factory(t) { return new (t || FileUploadService)(); };
FileUploadService.ɵprov = i0.ɵɵdefineInjectable({ factory: function FileUploadService_Factory() { return new FileUploadService(); }, token: FileUploadService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileUploadService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class FileUploadComponent {
    constructor(fileUploadService) {
        this.fileUploadService = fileUploadService;
        /**
         * @description Quando adiciona um arquivo no file upload
         * @returns { File[] } Lista de arquivo
         */
        this.onFileAdd = new EventEmitter();
        /**
         * @description Quando remove o arquivo do file upload
         * @returns { File[] } Lista de arquivo
         */
        this.onFileRemove = new EventEmitter();
        /**
         * @description Label que irá aparecer sobre o file upload
         */
        this.label = 'Clique aqui para enviar os arquivos';
        /**
         * @description Tipos de arquivos que serão aceitos
         * @example image/*
         */
        this.accept = '*';
        /**
         * @description Quando for true o file upload irá permitir subir mais de um arquivo
         */
        this.multiple = true;
        this.files = [];
    }
    ngOnInit() {
        this.fileUploadService.fileUploadAsync.subscribe((action) => this.onAction(action));
    }
    onAction(action) {
        switch (action) {
            case 'init' || 'clear':
                this.files = [];
                break;
            default:
                this.files = [];
                break;
        }
    }
    onSelect(event) {
        if (this.multiple === false) {
            this.files = [...event.addedFiles];
        }
        else {
            this.files.push(...event.addedFiles);
        }
        this.onFileAdd.emit(this.files);
    }
    onRemove(event) {
        this.files.splice(this.files.indexOf(event), 1);
        this.onFileRemove.emit(this.files);
    }
    /**
     * @description Método para limpar a lista de arquivos
     * @type { void }
     */
    clearFiles() {
        this.files = [];
    }
}
FileUploadComponent.ɵfac = function FileUploadComponent_Factory(t) { return new (t || FileUploadComponent)(ɵngcc0.ɵɵdirectiveInject(FileUploadService)); };
FileUploadComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FileUploadComponent, selectors: [["dharma-file-upload"]], inputs: { label: "label", accept: "accept", multiple: "multiple" }, outputs: { onFileAdd: "onFileAdd", onFileRemove: "onFileRemove" }, decls: 7, vars: 5, consts: [["ngx-dropzone", "", 1, "custom-dropzone", 3, "multiple", "accept", "change"], ["ngProjectAs", "ngx-dropzone-preview", 5, ["ngx-dropzone-preview"], 3, "file", "removable", "removed", 4, "ngFor", "ngForOf"], ["class", "text-center", 4, "ngIf"], ["ngProjectAs", "ngx-dropzone-preview", 5, ["ngx-dropzone-preview"], 3, "file", "removable", "removed"], [1, "text-center"], [1, "slide-text"]], template: function FileUploadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("change", function FileUploadComponent_Template_div_change_0_listener($event) { return ctx.onSelect($event); });
        ɵngcc0.ɵɵelementStart(1, "ngx-dropzone-label");
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵelementStart(3, "h2");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, FileUploadComponent_ngx_dropzone_image_preview_5_Template, 1, 2, "ngx-dropzone-image-preview", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, FileUploadComponent_div_6_Template, 3, 0, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("multiple", ctx.multiple)("accept", ctx.accept);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.files);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.files.length > 3);
    } }, directives: function () { return [NgxDropzoneComponent, NgxDropzoneLabelDirective, ɵngcc2.NgForOf, ɵngcc2.NgIf, NgxDropzoneImagePreviewComponent]; }, styles: [".slide-text[_ngcontent-%COMP%]{color:#3d464d}"] });
FileUploadComponent.ctorParameters = () => [
    { type: FileUploadService }
];
FileUploadComponent.propDecorators = {
    onFileAdd: [{ type: Output }],
    onFileRemove: [{ type: Output }],
    label: [{ type: Input }],
    accept: [{ type: Input }],
    multiple: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileUploadComponent, [{
        type: Component,
        args: [{
                selector: 'dharma-file-upload',
                template: "<div class=\"custom-dropzone\" ngx-dropzone [multiple]=\"multiple\" [accept]=\"accept\" (change)=\"onSelect($event)\">\n\t<ngx-dropzone-label>\n\t\t<div>\n\t\t\t<h2>{{ label }}</h2>\n\t\t</div>\n\t</ngx-dropzone-label>\n\t<ngx-dropzone-image-preview ngProjectAs=\"ngx-dropzone-preview\" *ngFor=\"let file of files\" [file]=\"file\" [removable]=\"true\" (removed)=\"onRemove(file)\"></ngx-dropzone-image-preview>\n</div>\n\n<div class=\"text-center\" *ngIf=\"files.length > 3\">\n    <p class=\"slide-text\"><---------- Deslize para ver todos os arquivos ----------></p>\n</div>\n",
                styles: [".slide-text{color:#3d464d}"]
            }]
    }], function () { return [{ type: FileUploadService }]; }, { onFileAdd: [{
            type: Output
        }], onFileRemove: [{
            type: Output
        }], label: [{
            type: Input
        }], accept: [{
            type: Input
        }], multiple: [{
            type: Input
        }] }); })();

class NgxDropzoneLabelDirective {
}
NgxDropzoneLabelDirective.ɵfac = function NgxDropzoneLabelDirective_Factory(t) { return new (t || NgxDropzoneLabelDirective)(); };
NgxDropzoneLabelDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NgxDropzoneLabelDirective, selectors: [["ngx-dropzone-label"]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDropzoneLabelDirective, [{
        type: Directive,
        args: [{
                selector: 'ngx-dropzone-label'
            }]
    }], null, null); })();

/**
 * Coerces a data-bound value (typically a string) to a boolean.
 * Taken from https://github.com/angular/components/blob/master/src/cdk/coercion/boolean-property.ts
 */
function coerceBooleanProperty(value) {
    return value != null && `${value}` !== 'false';
}
/**
 * Whether the provided value is considered a number.
 * Taken from https://github.com/angular/components/blob/master/src/cdk/coercion/number-property.ts
 */
function coerceNumberProperty(value) {
    // parseFloat(value) handles most of the cases we're interested in (it treats null, empty string,
    // and other non-number values as NaN, where Number just uses 0) but it considers the string
    // '123hello' to be a valid number. Therefore we also check if Number(value) is NaN.
    return (!isNaN(parseFloat(value)) && !isNaN(Number(value))) ? Number(value) : null;
}

var KEY_CODE;
(function (KEY_CODE) {
    KEY_CODE[KEY_CODE["BACKSPACE"] = 8] = "BACKSPACE";
    KEY_CODE[KEY_CODE["DELETE"] = 46] = "DELETE";
})(KEY_CODE || (KEY_CODE = {}));
class NgxDropzonePreviewComponent {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this._removable = false;
        /** Emitted when the element should be removed. */
        this.removed = new EventEmitter();
        /** Make the preview item focusable using the tab key. */
        this.tabIndex = 0;
    }
    /** Allow the user to remove files. */
    get removable() {
        return this._removable;
    }
    set removable(value) {
        this._removable = coerceBooleanProperty(value);
    }
    keyEvent(event) {
        switch (event.keyCode) {
            case KEY_CODE.BACKSPACE:
            case KEY_CODE.DELETE:
                this.remove();
                break;
            default:
                break;
        }
    }
    /** We use the HostBinding to pass these common styles to child components. */
    get hostStyle() {
        const styles = `
			display: flex;
			height: 140px;
			min-height: 140px;
			min-width: 180px;
			max-width: 180px;
			justify-content: center;
			align-items: center;
			padding: 0 20px;
			margin: 10px;
			border-radius: 5px;
			position: relative;
		`;
        return this.sanitizer.bypassSecurityTrustStyle(styles);
    }
    /** Remove method to be used from the template. */
    _remove(event) {
        event.stopPropagation();
        this.remove();
    }
    /** Remove the preview item (use from component code). */
    remove() {
        if (this._removable) {
            this.removed.next(this.file);
        }
    }
    isFileImage(file) {
        file = file ? file : this.file;
        const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
        return file && acceptedImageTypes.includes(file['type']);
    }
    readFile() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                if (!this.isFileImage(this.file)) {
                    resolve('https://i.ibb.co/hyqPY6B/folder.png');
                }
                const reader = new FileReader();
                reader.onload = e => {
                    resolve(e.target.result);
                };
                reader.onerror = e => {
                    console.error(`FileReader failed on file ${this.file.name}.`);
                    reject(e);
                };
                if (!this.file) {
                    return reject('No file to read. Please provide a file using the [file] Input property.');
                }
                reader.readAsDataURL(this.file);
            });
        });
    }
}
NgxDropzonePreviewComponent.ɵfac = function NgxDropzonePreviewComponent_Factory(t) { return new (t || NgxDropzonePreviewComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.DomSanitizer)); };
NgxDropzonePreviewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxDropzonePreviewComponent, selectors: [["ngx-dropzone-preview"]], hostVars: 3, hostBindings: function NgxDropzonePreviewComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keyup", function NgxDropzonePreviewComponent_keyup_HostBindingHandler($event) { return ctx.keyEvent($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("tabindex", ctx.tabIndex);
        ɵngcc0.ɵɵstyleMap(ctx.hostStyle);
    } }, inputs: { removable: "removable", file: "file" }, outputs: { removed: "removed" }, ngContentSelectors: _c4, decls: 2, vars: 1, consts: [[3, "click", 4, "ngIf"], [3, "click"]], template: function NgxDropzonePreviewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c3);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵtemplate(1, NgxDropzonePreviewComponent_ngx_dropzone_remove_badge_1_Template, 1, 0, "ngx-dropzone-remove-badge", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.removable);
    } }, directives: function () { return [ɵngcc2.NgIf, NgxDropzoneRemoveBadgeComponent]; }, styles: ["[_nghost-%COMP%]{background-image:linear-gradient(0deg,#ededed,#efefef,#f1f1f1,#f4f4f4,#f6f6f6)}[_nghost-%COMP%]:focus, [_nghost-%COMP%]:hover{background-image:linear-gradient(0deg,#e3e3e3,#ebeaea,#e8e7e7,#ebeaea,#f4f4f4);outline:0}[_nghost-%COMP%]:focus   ngx-dropzone-remove-badge[_ngcontent-%COMP%], [_nghost-%COMP%]:hover   ngx-dropzone-remove-badge[_ngcontent-%COMP%]{opacity:1}[_nghost-%COMP%]   ngx-dropzone-remove-badge[_ngcontent-%COMP%]{opacity:0}[_nghost-%COMP%]     ngx-dropzone-label{overflow-wrap:break-word}"] });
NgxDropzonePreviewComponent.ctorParameters = () => [
    { type: DomSanitizer }
];
NgxDropzonePreviewComponent.propDecorators = {
    file: [{ type: Input }],
    removable: [{ type: Input }],
    removed: [{ type: Output }],
    keyEvent: [{ type: HostListener, args: ['keyup', ['$event'],] }],
    hostStyle: [{ type: HostBinding, args: ['style',] }],
    tabIndex: [{ type: HostBinding, args: ['tabindex',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDropzonePreviewComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-dropzone-preview',
                template: `
		<ng-content select="ngx-dropzone-label"></ng-content>
		<ngx-dropzone-remove-badge *ngIf="removable" (click)="_remove($event)">
		</ngx-dropzone-remove-badge>
	`,
                styles: [":host(){background-image:linear-gradient(0deg,#ededed,#efefef,#f1f1f1,#f4f4f4,#f6f6f6)}:host():focus,:host():hover{background-image:linear-gradient(0deg,#e3e3e3,#ebeaea,#e8e7e7,#ebeaea,#f4f4f4);outline:0}:host():focus ngx-dropzone-remove-badge,:host():hover ngx-dropzone-remove-badge{opacity:1}:host() ngx-dropzone-remove-badge{opacity:0}:host() ::ng-deep ngx-dropzone-label{overflow-wrap:break-word}"]
            }]
    }], function () { return [{ type: ɵngcc3.DomSanitizer }]; }, { removed: [{
            type: Output
        }], tabIndex: [{
            type: HostBinding,
            args: ['tabindex']
        }], removable: [{
            type: Input
        }], keyEvent: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }], hostStyle: [{
            type: HostBinding,
            args: ['style']
        }], file: [{
            type: Input
        }] }); })();

/**
 * This service contains the filtering logic to be applied to
 * any dropped or selected file. If a file matches all criteria
 * like maximum size or accept type, it will be emitted in the
 * addedFiles array, otherwise in the rejectedFiles array.
 */
class NgxDropzoneService {
    parseFileList(files, accept, maxFileSize, multiple) {
        const addedFiles = [];
        const rejectedFiles = [];
        for (let i = 0; i < files.length; i++) {
            const file = files.item(i);
            if (!this.isAccepted(file, accept)) {
                this.rejectFile(rejectedFiles, file, 'type');
                continue;
            }
            if (maxFileSize && file.size > maxFileSize) {
                this.rejectFile(rejectedFiles, file, 'size');
                continue;
            }
            if (!multiple && addedFiles.length >= 1) {
                this.rejectFile(rejectedFiles, file, 'no_multiple');
                continue;
            }
            addedFiles.push(file);
        }
        const result = {
            addedFiles,
            rejectedFiles
        };
        return result;
    }
    isAccepted(file, accept) {
        if (accept === '*') {
            return true;
        }
        const acceptFiletypes = accept.split(',').map(it => it.toLowerCase().trim());
        const filetype = file.type.toLowerCase();
        const filename = file.name.toLowerCase();
        const matchedFileType = acceptFiletypes.find(acceptFiletype => {
            // check for wildcard mimetype (e.g. image/*)
            if (acceptFiletype.endsWith('/*')) {
                return filetype.split('/')[0] === acceptFiletype.split('/')[0];
            }
            // check for file extension (e.g. .csv)
            if (acceptFiletype.startsWith(".")) {
                return filename.endsWith(acceptFiletype);
            }
            // check for exact mimetype match (e.g. image/jpeg)
            return acceptFiletype == filetype;
        });
        return !!matchedFileType;
    }
    rejectFile(rejectedFiles, file, reason) {
        const rejectedFile = file;
        rejectedFile.reason = reason;
        rejectedFiles.push(rejectedFile);
    }
}
NgxDropzoneService.ɵfac = function NgxDropzoneService_Factory(t) { return new (t || NgxDropzoneService)(); };
NgxDropzoneService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NgxDropzoneService, factory: NgxDropzoneService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDropzoneService, [{
        type: Injectable
    }], null, null); })();

class NgxDropzoneComponent {
    constructor(service) {
        this.service = service;
        /** Emitted when any files were added or rejected. */
        this.change = new EventEmitter();
        /** Set the accepted file types. Defaults to '*'. */
        this.accept = '*';
        this._disabled = false;
        this._multiple = true;
        this._maxFileSize = undefined;
        this._expandable = false;
        this._disableClick = false;
        this._isHovered = false;
    }
    get _hasPreviews() {
        return !!this._previewChildren.length;
    }
    /** Disable any user interaction with the component. */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        if (this._isHovered) {
            this._isHovered = false;
        }
    }
    /** Allow the selection of multiple files. */
    get multiple() {
        return this._multiple;
    }
    set multiple(value) {
        this._multiple = coerceBooleanProperty(value);
    }
    /** Set the maximum size a single file may have. */
    get maxFileSize() {
        return this._maxFileSize;
    }
    set maxFileSize(value) {
        this._maxFileSize = coerceNumberProperty(value);
    }
    /** Allow the dropzone container to expand vertically. */
    get expandable() {
        return this._expandable;
    }
    set expandable(value) {
        this._expandable = coerceBooleanProperty(value);
    }
    /** Open the file selector on click. */
    get disableClick() {
        return this._disableClick;
    }
    set disableClick(value) {
        this._disableClick = coerceBooleanProperty(value);
    }
    /** Show the native OS file explorer to select files. */
    _onClick() {
        if (!this.disableClick) {
            this.showFileSelector();
        }
    }
    _onDragOver(event) {
        if (this.disabled) {
            return;
        }
        this.preventDefault(event);
        this._isHovered = true;
    }
    _onDragLeave() {
        this._isHovered = false;
    }
    _onDrop(event) {
        if (this.disabled) {
            return;
        }
        this.preventDefault(event);
        this._isHovered = false;
        this.handleFileDrop(event.dataTransfer.files);
    }
    showFileSelector() {
        if (!this.disabled) {
            this._fileInput.nativeElement.click();
        }
    }
    _onFilesSelected(event) {
        const files = event.target.files;
        this.handleFileDrop(files);
        // Reset the native file input element to allow selecting the same file again
        this._fileInput.nativeElement.value = '';
        // fix(#32): Prevent the default event behaviour which caused the change event to emit twice.
        this.preventDefault(event);
    }
    handleFileDrop(files) {
        const result = this.service.parseFileList(files, this.accept, this.maxFileSize, this.multiple);
        this.change.next({
            addedFiles: result.addedFiles,
            rejectedFiles: result.rejectedFiles,
            source: this
        });
    }
    preventDefault(event) {
        event.preventDefault();
        event.stopPropagation();
    }
}
NgxDropzoneComponent.ɵfac = function NgxDropzoneComponent_Factory(t) { return new (t || NgxDropzoneComponent)(ɵngcc0.ɵɵdirectiveInject(NgxDropzoneService, 2)); };
NgxDropzoneComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxDropzoneComponent, selectors: [["ngx-dropzone"], ["", "ngx-dropzone", ""]], contentQueries: function NgxDropzoneComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgxDropzonePreviewComponent, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._previewChildren = _t);
    } }, viewQuery: function NgxDropzoneComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._fileInput = _t.first);
    } }, hostVars: 8, hostBindings: function NgxDropzoneComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NgxDropzoneComponent_click_HostBindingHandler() { return ctx._onClick(); })("dragover", function NgxDropzoneComponent_dragover_HostBindingHandler($event) { return ctx._onDragOver($event); })("dragleave", function NgxDropzoneComponent_dragleave_HostBindingHandler() { return ctx._onDragLeave(); })("drop", function NgxDropzoneComponent_drop_HostBindingHandler($event) { return ctx._onDrop($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ngx-dz-hovered", ctx._isHovered)("ngx-dz-disabled", ctx.disabled)("expandable", ctx.expandable)("unclickable", ctx.disableClick);
    } }, inputs: { accept: "accept", disabled: "disabled", multiple: "multiple", maxFileSize: "maxFileSize", expandable: "expandable", disableClick: "disableClick", id: "id", ariaLabel: ["aria-label", "ariaLabel"], ariaLabelledby: ["aria-labelledby", "ariaLabelledby"], ariaDescribedBy: ["aria-describedby", "ariaDescribedBy"] }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([NgxDropzoneService])], ngContentSelectors: _c7, decls: 5, vars: 8, consts: [["type", "file", 3, "id", "multiple", "accept", "disabled", "change"], ["fileInput", ""], [4, "ngIf"]], template: function NgxDropzoneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c6);
        ɵngcc0.ɵɵelementStart(0, "input", 0, 1);
        ɵngcc0.ɵɵlistener("change", function NgxDropzoneComponent_Template_input_change_0_listener($event) { return ctx._onFilesSelected($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, NgxDropzoneComponent_ng_content_2_Template, 1, 0, "ng-content", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵprojection(4, 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id)("multiple", ctx.multiple)("accept", ctx.accept)("disabled", ctx.disabled);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel)("aria-labelledby", ctx.ariaLabelledby)("aria-describedby", ctx.ariaDescribedBy);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx._hasPreviews);
    } }, directives: [ɵngcc2.NgIf], styles: ["[_nghost-%COMP%]{display:flex;align-items:center;height:180px;background:#fff;cursor:pointer;color:#717386;border:2px dashed #717386;border-radius:5px;font-size:16px;overflow-x:auto}.ngx-dz-hovered[_nghost-%COMP%]{border-style:solid}.ngx-dz-disabled[_nghost-%COMP%]{opacity:.5;cursor:no-drop;pointer-events:none}.expandable[_nghost-%COMP%]{overflow:hidden;height:unset;min-height:180px;flex-wrap:wrap}.unclickable[_nghost-%COMP%]{cursor:default}[_nghost-%COMP%]     ngx-dropzone-label{text-align:center;z-index:10;margin:10px auto}[_nghost-%COMP%]   input[_ngcontent-%COMP%]{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:focus +   ngx-dropzone-label{outline:1px dotted #000;outline:5px auto -webkit-focus-ring-color}"] });
NgxDropzoneComponent.ctorParameters = () => [
    { type: NgxDropzoneService, decorators: [{ type: Self }] }
];
NgxDropzoneComponent.propDecorators = {
    _previewChildren: [{ type: ContentChildren, args: [NgxDropzonePreviewComponent, { descendants: true },] }],
    _fileInput: [{ type: ViewChild, args: ['fileInput', { static: false },] }],
    change: [{ type: Output }],
    accept: [{ type: Input }],
    disabled: [{ type: Input }, { type: HostBinding, args: ['class.ngx-dz-disabled',] }],
    multiple: [{ type: Input }],
    maxFileSize: [{ type: Input }],
    expandable: [{ type: Input }, { type: HostBinding, args: ['class.expandable',] }],
    disableClick: [{ type: Input }, { type: HostBinding, args: ['class.unclickable',] }],
    id: [{ type: Input }],
    ariaLabel: [{ type: Input, args: ['aria-label',] }],
    ariaLabelledby: [{ type: Input, args: ['aria-labelledby',] }],
    ariaDescribedBy: [{ type: Input, args: ['aria-describedby',] }],
    _isHovered: [{ type: HostBinding, args: ['class.ngx-dz-hovered',] }],
    _onClick: [{ type: HostListener, args: ['click',] }],
    _onDragOver: [{ type: HostListener, args: ['dragover', ['$event'],] }],
    _onDragLeave: [{ type: HostListener, args: ['dragleave',] }],
    _onDrop: [{ type: HostListener, args: ['drop', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDropzoneComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-dropzone, [ngx-dropzone]',
                template: "<input #fileInput type=\"file\" [id]=\"id\" [multiple]=\"multiple\" [accept]=\"accept\" [disabled]=\"disabled\"\n  (change)=\"_onFilesSelected($event)\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\"\n  [attr.aria-describedby]=\"ariaDescribedBy\">\n<ng-content select=\"ngx-dropzone-label\" *ngIf=\"!_hasPreviews\"></ng-content>\n<ng-content select=\"ngx-dropzone-preview\"></ng-content>\n<ng-content></ng-content>\n",
                providers: [NgxDropzoneService],
                styles: [":host(){display:flex;align-items:center;height:180px;background:#fff;cursor:pointer;color:#717386;border:2px dashed #717386;border-radius:5px;font-size:16px;overflow-x:auto}:host().ngx-dz-hovered{border-style:solid}:host().ngx-dz-disabled{opacity:.5;cursor:no-drop;pointer-events:none}:host().expandable{overflow:hidden;height:unset;min-height:180px;flex-wrap:wrap}:host().unclickable{cursor:default}:host() ::ng-deep ngx-dropzone-label{text-align:center;z-index:10;margin:10px auto}:host() input{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}:host() input:focus+::ng-deep ngx-dropzone-label{outline:1px dotted #000;outline:5px auto -webkit-focus-ring-color}"]
            }]
    }], function () { return [{ type: NgxDropzoneService, decorators: [{
                type: Self
            }] }]; }, { change: [{
            type: Output
        }], accept: [{
            type: Input
        }], _isHovered: [{
            type: HostBinding,
            args: ['class.ngx-dz-hovered']
        }], disabled: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.ngx-dz-disabled']
        }], multiple: [{
            type: Input
        }], maxFileSize: [{
            type: Input
        }], expandable: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.expandable']
        }], disableClick: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.unclickable']
        }], 
    /** Show the native OS file explorer to select files. */
    _onClick: [{
            type: HostListener,
            args: ['click']
        }], _onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], _onDragLeave: [{
            type: HostListener,
            args: ['dragleave']
        }], _onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }], _previewChildren: [{
            type: ContentChildren,
            args: [NgxDropzonePreviewComponent, { descendants: true }]
        }], _fileInput: [{
            type: ViewChild,
            args: ['fileInput', { static: false }]
        }], id: [{
            type: Input
        }], ariaLabel: [{
            type: Input,
            args: ['aria-label']
        }], ariaLabelledby: [{
            type: Input,
            args: ['aria-labelledby']
        }], ariaDescribedBy: [{
            type: Input,
            args: ['aria-describedby']
        }] }); })();

class NgxDropzoneImagePreviewComponent extends NgxDropzonePreviewComponent {
    constructor(sanitizer) {
        super(sanitizer);
        /** The image data source. */
        this.imageSrc = '';
    }
    ngOnInit() {
        this.readFile()
            .then(img => {
            setTimeout(() => this.imageSrc = img);
        })
            .catch(err => console.error(err));
    }
}
NgxDropzoneImagePreviewComponent.ɵfac = function NgxDropzoneImagePreviewComponent_Factory(t) { return new (t || NgxDropzoneImagePreviewComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.DomSanitizer)); };
NgxDropzoneImagePreviewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxDropzoneImagePreviewComponent, selectors: [["ngx-dropzone-image-preview"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NgxDropzonePreviewComponent,
                useExisting: NgxDropzoneImagePreviewComponent
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c4, decls: 5, vars: 4, consts: [[3, "src", 4, "ngIf"], ["class", "folder", 3, "src", 4, "ngIf"], [4, "ngIf"], [3, "click", 4, "ngIf"], [3, "src"], [1, "folder", 3, "src"], [3, "click"]], template: function NgxDropzoneImagePreviewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c3);
        ɵngcc0.ɵɵtemplate(0, NgxDropzoneImagePreviewComponent_img_0_Template, 1, 1, "img", 0);
        ɵngcc0.ɵɵtemplate(1, NgxDropzoneImagePreviewComponent_img_1_Template, 1, 1, "img", 1);
        ɵngcc0.ɵɵtemplate(2, NgxDropzoneImagePreviewComponent_p_2_Template, 2, 1, "p", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵtemplate(4, NgxDropzoneImagePreviewComponent_ngx_dropzone_remove_badge_4_Template, 1, 0, "ngx-dropzone-remove-badge", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isFileImage());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isFileImage());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isFileImage());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.removable);
    } }, directives: function () { return [ɵngcc2.NgIf, NgxDropzoneRemoveBadgeComponent]; }, styles: ["[_nghost-%COMP%]{min-width:unset!important;max-width:unset!important;padding:20!important}[_nghost-%COMP%]:focus   img[_ngcontent-%COMP%], [_nghost-%COMP%]:hover   img[_ngcontent-%COMP%]{opacity:.7}[_nghost-%COMP%]:focus   ngx-dropzone-remove-badge[_ngcontent-%COMP%], [_nghost-%COMP%]:hover   ngx-dropzone-remove-badge[_ngcontent-%COMP%]{opacity:1}[_nghost-%COMP%]   ngx-dropzone-remove-badge[_ngcontent-%COMP%]{opacity:0}[_nghost-%COMP%]   img[_ngcontent-%COMP%]{max-height:100%;border-radius:5px;opacity:.8}[_nghost-%COMP%]   .folder[_ngcontent-%COMP%]{width:70px;margin-left:10px;margin-top:-50px}[_nghost-%COMP%]   p[_ngcontent-%COMP%]{width:140px;max-width:15ch;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-top:30px;margin-left:20px;position:absolute}[_nghost-%COMP%]     ngx-dropzone-label{position:absolute;overflow-wrap:break-word}"] });
NgxDropzoneImagePreviewComponent.ctorParameters = () => [
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDropzoneImagePreviewComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-dropzone-image-preview',
                template: `
    <img *ngIf="isFileImage()" [src]="imageSrc" />
    <img *ngIf="!isFileImage()" [src]="imageSrc" class="folder" />
    <p *ngIf="!isFileImage()">{{ file?.name }}</p>
		<ng-content select="ngx-dropzone-label"></ng-content>
    <ngx-dropzone-remove-badge *ngIf="removable" (click)="_remove($event)">
    </ngx-dropzone-remove-badge>
	`,
                providers: [
                    {
                        provide: NgxDropzonePreviewComponent,
                        useExisting: NgxDropzoneImagePreviewComponent
                    }
                ],
                styles: [":host(){min-width:unset!important;max-width:unset!important;padding:20!important}:host():focus img,:host():hover img{opacity:.7}:host():focus ngx-dropzone-remove-badge,:host():hover ngx-dropzone-remove-badge{opacity:1}:host() ngx-dropzone-remove-badge{opacity:0}:host() img{max-height:100%;border-radius:5px;opacity:.8}:host() .folder{width:70px;margin-left:10px;margin-top:-50px}:host() p{width:140px;max-width:15ch;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-top:30px;margin-left:20px;position:absolute}:host() ::ng-deep ngx-dropzone-label{position:absolute;overflow-wrap:break-word}"]
            }]
    }], function () { return [{ type: ɵngcc3.DomSanitizer }]; }, null); })();

class NgxDropzoneRemoveBadgeComponent {
}
NgxDropzoneRemoveBadgeComponent.ɵfac = function NgxDropzoneRemoveBadgeComponent_Factory(t) { return new (t || NgxDropzoneRemoveBadgeComponent)(); };
NgxDropzoneRemoveBadgeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxDropzoneRemoveBadgeComponent, selectors: [["ngx-dropzone-remove-badge"]], decls: 3, vars: 0, consts: [["x1", "0", "y1", "0", "x2", "10", "y2", "10"], ["x1", "0", "y1", "10", "x2", "10", "y2", "0"]], template: function NgxDropzoneRemoveBadgeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg");
        ɵngcc0.ɵɵelement(1, "line", 0);
        ɵngcc0.ɵɵelement(2, "line", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["[_nghost-%COMP%]{display:flex;justify-content:center;align-items:center;height:22px;width:22px;position:absolute;top:5px;right:5px;border-radius:50%;background:#bbb;color:#333;cursor:pointer}[_nghost-%COMP%]:hover{background:#aeaeae}[_nghost-%COMP%] > svg[_ngcontent-%COMP%]{height:10px;width:10px}[_nghost-%COMP%] > svg[_ngcontent-%COMP%] > line[_ngcontent-%COMP%]{stroke-width:2px;stroke:#fff}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDropzoneRemoveBadgeComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-dropzone-remove-badge',
                template: `
    <svg>
      <line x1="0" y1="0" x2="10" y2="10" />
      <line x1="0" y1="10" x2="10" y2="0" />
    </svg>
  `,
                styles: [":host(){display:flex;justify-content:center;align-items:center;height:22px;width:22px;position:absolute;top:5px;right:5px;border-radius:50%;background:#bbb;color:#333;cursor:pointer}:host():hover{background:#aeaeae}:host()>svg{height:10px;width:10px}:host()>svg>line{stroke-width:2px;stroke:#fff}"]
            }]
    }], null, null); })();

class NgxDropzoneVideoPreviewComponent extends NgxDropzonePreviewComponent {
    constructor(sanitizer) {
        super(sanitizer);
    }
    ngOnInit() {
        if (!this.file) {
            console.error('No file to read. Please provide a file using the [file] Input property.');
            return;
        }
        /**
         * We sanitize the URL here to enable the preview.
         * Please note that this could cause security issues!
         **/
        this.videoSrc = URL.createObjectURL(this.file);
        this.sanitizedVideoSrc = this.sanitizer.bypassSecurityTrustUrl(this.videoSrc);
    }
    ngOnDestroy() {
        URL.revokeObjectURL(this.videoSrc);
    }
}
NgxDropzoneVideoPreviewComponent.ɵfac = function NgxDropzoneVideoPreviewComponent_Factory(t) { return new (t || NgxDropzoneVideoPreviewComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.DomSanitizer)); };
NgxDropzoneVideoPreviewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxDropzoneVideoPreviewComponent, selectors: [["ngx-dropzone-video-preview"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NgxDropzonePreviewComponent,
                useExisting: NgxDropzoneVideoPreviewComponent
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c4, decls: 3, vars: 2, consts: [["controls", "", 3, "click", 4, "ngIf"], [3, "click", 4, "ngIf"], ["controls", "", 3, "click"], [3, "src"], [3, "click"]], template: function NgxDropzoneVideoPreviewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c3);
        ɵngcc0.ɵɵtemplate(0, NgxDropzoneVideoPreviewComponent_video_0_Template, 2, 1, "video", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵtemplate(2, NgxDropzoneVideoPreviewComponent_ngx_dropzone_remove_badge_2_Template, 1, 0, "ngx-dropzone-remove-badge", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.sanitizedVideoSrc);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.removable);
    } }, directives: [ɵngcc2.NgIf, NgxDropzoneRemoveBadgeComponent], styles: ["[_nghost-%COMP%]{min-width:unset!important;max-width:unset!important;padding:0!important}[_nghost-%COMP%]:focus   video[_ngcontent-%COMP%], [_nghost-%COMP%]:hover   video[_ngcontent-%COMP%]{opacity:.7}[_nghost-%COMP%]:focus   ngx-dropzone-remove-badge[_ngcontent-%COMP%], [_nghost-%COMP%]:hover   ngx-dropzone-remove-badge[_ngcontent-%COMP%]{opacity:1}[_nghost-%COMP%]   ngx-dropzone-remove-badge[_ngcontent-%COMP%]{opacity:0}[_nghost-%COMP%]   video[_ngcontent-%COMP%]{max-height:100%;border-radius:5px}[_nghost-%COMP%]     ngx-dropzone-label{position:absolute;overflow-wrap:break-word}"] });
NgxDropzoneVideoPreviewComponent.ctorParameters = () => [
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDropzoneVideoPreviewComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-dropzone-video-preview',
                template: `
    <video *ngIf="sanitizedVideoSrc" controls (click)="$event.stopPropagation()">
      <source [src]="sanitizedVideoSrc" />
    </video>
    <ng-content select="ngx-dropzone-label"></ng-content>
    <ngx-dropzone-remove-badge *ngIf="removable" (click)="_remove($event)">
    </ngx-dropzone-remove-badge>
	`,
                providers: [
                    {
                        provide: NgxDropzonePreviewComponent,
                        useExisting: NgxDropzoneVideoPreviewComponent
                    }
                ],
                styles: [":host(){min-width:unset!important;max-width:unset!important;padding:0!important}:host():focus video,:host():hover video{opacity:.7}:host():focus ngx-dropzone-remove-badge,:host():hover ngx-dropzone-remove-badge{opacity:1}:host() ngx-dropzone-remove-badge{opacity:0}:host() video{max-height:100%;border-radius:5px}:host() ::ng-deep ngx-dropzone-label{position:absolute;overflow-wrap:break-word}"]
            }]
    }], function () { return [{ type: ɵngcc3.DomSanitizer }]; }, null); })();

class NgxDropzoneModule {
}
NgxDropzoneModule.ɵfac = function NgxDropzoneModule_Factory(t) { return new (t || NgxDropzoneModule)(); };
NgxDropzoneModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxDropzoneModule });
NgxDropzoneModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxDropzoneModule, { declarations: function () { return [NgxDropzoneComponent, NgxDropzoneLabelDirective, NgxDropzonePreviewComponent, NgxDropzoneImagePreviewComponent, NgxDropzoneRemoveBadgeComponent, NgxDropzoneVideoPreviewComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxDropzoneComponent, NgxDropzoneLabelDirective, NgxDropzonePreviewComponent, NgxDropzoneImagePreviewComponent, NgxDropzoneRemoveBadgeComponent, NgxDropzoneVideoPreviewComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDropzoneModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    NgxDropzoneComponent,
                    NgxDropzoneLabelDirective,
                    NgxDropzonePreviewComponent,
                    NgxDropzoneImagePreviewComponent,
                    NgxDropzoneRemoveBadgeComponent,
                    NgxDropzoneVideoPreviewComponent,
                ],
                exports: [
                    NgxDropzoneComponent,
                    NgxDropzoneLabelDirective,
                    NgxDropzonePreviewComponent,
                    NgxDropzoneImagePreviewComponent,
                    NgxDropzoneRemoveBadgeComponent,
                    NgxDropzoneVideoPreviewComponent,
                ]
            }]
    }], null, null); })();

class FileUploadModule {
}
FileUploadModule.ɵfac = function FileUploadModule_Factory(t) { return new (t || FileUploadModule)(); };
FileUploadModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FileUploadModule });
FileUploadModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [FileUploadService], imports: [[
            CommonModule,
            NgxDropzoneModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FileUploadModule, { declarations: function () { return [FileUploadComponent]; }, imports: function () { return [CommonModule, NgxDropzoneModule]; }, exports: function () { return [FileUploadComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileUploadModule, [{
        type: NgModule,
        args: [{
                declarations: [FileUploadComponent],
                imports: [
                    CommonModule,
                    NgxDropzoneModule,
                ],
                providers: [FileUploadService],
                exports: [FileUploadComponent]
            }]
    }], null, null); })();

class CountdownTimerComponent {
    constructor(zone) {
        this.zone = zone;
        this.onFinish = new EventEmitter();
        /**
         * @description Tempo em milisegundos
         */
        this.timeLeft = 180000;
        this.cssStyle = {};
        this.showCircle = true;
    }
    ngOnInit() {
        this.start();
        this.zone.run(() => {
            this.circle.nativeElement.style.cssText = `animation : countdown ${this.convertMilisecondsToSecond(this.timeLeft).toString()}s linear infinite forwards`;
        });
    }
    convertMilisecondsToSecond(milisecond) {
        return Math.round((milisecond) / 1000);
    }
    start() {
        this.currentTime = +this.timeLeft;
        setInterval(() => {
            this.currentTime = this.currentTime > 0 ? this.currentTime - 1000 : 0;
            this.displayTimeFunction(this.currentTime);
            if (this.currentTime === 0) {
                this.onFinish.emit(true);
            }
        }, 1000);
        setTimeout(() => {
            this.startAgain();
        }, 10000);
    }
    startAgain() {
        this.zone.run(() => {
            this.currentTime = this.timeLeft;
            this.showCircle = false;
            setTimeout(() => {
                this.showCircle = true;
            }, 100);
        });
    }
    displayTimeFunction(currentTime) {
        this.zone.run(() => {
            const tempTime = moment.duration(currentTime);
            if (tempTime.minutes() > 0) {
                this.displayTime = `${tempTime.minutes()} minutos ${tempTime.seconds()} segundos`;
            }
            else {
                this.displayTime = `${tempTime.seconds()} segundos`;
            }
        });
    }
}
CountdownTimerComponent.ɵfac = function CountdownTimerComponent_Factory(t) { return new (t || CountdownTimerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CountdownTimerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CountdownTimerComponent, selectors: [["dharma-countdown-timer"]], viewQuery: function CountdownTimerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c8, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.circle = _t.first);
    } }, inputs: { timeLeft: "timeLeft" }, outputs: { onFinish: "onFinish" }, decls: 7, vars: 2, consts: [["id", "countdown", 3, "hidden"], ["id", "animation", "r", "18", "cx", "20", "cy", "20"], ["circle", ""], ["id", "countdown-number"]], template: function CountdownTimerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0);
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(2, "svg");
        ɵngcc0.ɵɵelement(3, "circle", 1, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.showCircle);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.displayTime, " ");
    } }, styles: ["#countdown[_ngcontent-%COMP%]{position:relative;margin:auto;height:40px;width:40px;text-align:center}#countdown-number[_ngcontent-%COMP%]{color:#f7941d;display:inline-block;line-height:40px}svg[_ngcontent-%COMP%]{position:absolute;top:0;right:0;width:40px;height:40px;transform:rotateY(-180deg) rotate(-90deg)}svg[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke-dasharray:113px;stroke-dashoffset:0px;stroke-linecap:round;stroke-width:2px;stroke:#f7941d;fill:none}@-webkit-keyframes countdown{0%{stroke-dashoffset:0px}to{stroke-dashoffset:113px}}@keyframes countdown{0%{stroke-dashoffset:0px}to{stroke-dashoffset:113px}}"] });
CountdownTimerComponent.ctorParameters = () => [
    { type: NgZone }
];
CountdownTimerComponent.propDecorators = {
    circle: [{ type: ViewChild, args: ["circle", { static: true },] }],
    onFinish: [{ type: Output }],
    timeLeft: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CountdownTimerComponent, [{
        type: Component,
        args: [{
                selector: 'dharma-countdown-timer',
                template: "<ng-container>\n  <div id=\"countdown\" [hidden]=\"!showCircle\">\n    <svg>\n      <circle #circle id=\"animation\" r=\"18\" cx=\"20\" cy=\"20\"></circle>\n    </svg>\n  </div>\n  <div id=\"countdown-number\">\n    {{ displayTime }}\n  </div>\n</ng-container>",
                styles: ["#countdown{position:relative;margin:auto;height:40px;width:40px;text-align:center}#countdown-number{color:#f7941d;display:inline-block;line-height:40px}svg{position:absolute;top:0;right:0;width:40px;height:40px;transform:rotateY(-180deg) rotate(-90deg)}svg circle{stroke-dasharray:113px;stroke-dashoffset:0px;stroke-linecap:round;stroke-width:2px;stroke:#f7941d;fill:none}@-webkit-keyframes countdown{0%{stroke-dashoffset:0px}to{stroke-dashoffset:113px}}@keyframes countdown{0%{stroke-dashoffset:0px}to{stroke-dashoffset:113px}}"]
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, { onFinish: [{
            type: Output
        }], timeLeft: [{
            type: Input
        }], circle: [{
            type: ViewChild,
            args: ["circle", { static: true }]
        }] }); })();

class CountdownTimerModule {
}
CountdownTimerModule.ɵfac = function CountdownTimerModule_Factory(t) { return new (t || CountdownTimerModule)(); };
CountdownTimerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CountdownTimerModule });
CountdownTimerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CountdownTimerModule, { declarations: function () { return [CountdownTimerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CountdownTimerComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CountdownTimerModule, [{
        type: NgModule,
        args: [{
                declarations: [CountdownTimerComponent],
                imports: [
                    CommonModule
                ],
                exports: [CountdownTimerComponent]
            }]
    }], null, null); })();

class InputPasswordComponent {
    constructor() {
        this.placeholder = '';
        this.maxlength = 6;
        this.style = {};
        this.showPassword = false;
    }
    ngOnInit() {
        this.control.valueChanges.subscribe(value => {
            this.value = value;
        });
    }
    showOrHide() {
        this.showPassword = this.showPassword ? false : true;
        this.control.setValue(this.value);
    }
}
InputPasswordComponent.ɵfac = function InputPasswordComponent_Factory(t) { return new (t || InputPasswordComponent)(); };
InputPasswordComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: InputPasswordComponent, selectors: [["dharma-input-password"]], inputs: { placeholder: "placeholder", maxlength: "maxlength", style: "style", control: "control", formControlName: "formControlName" }, decls: 6, vars: 2, consts: [[1, "input-group"], ["type", "text", "type", "password", "class", "password form-control pwd", 3, "formControl", "placeholder", "ngStyle", "maxlength", "id", 4, "ngIf"], ["type", "password", "type", "text", "class", "password form-control pwd", 3, "formControl", "placeholder", "ngStyle", "maxlength", "id", 4, "ngIf"], [1, "input-group-btn", 3, "click"], ["type", "button", 1, "btn", "btn-default", "reveal"], [1, "icon", "fa", "fa-eye"], ["type", "text", "type", "password", 1, "password", "form-control", "pwd", 3, "formControl", "placeholder", "ngStyle", "maxlength", "id"], ["type", "password", "type", "text", 1, "password", "form-control", "pwd", 3, "formControl", "placeholder", "ngStyle", "maxlength", "id"]], template: function InputPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, InputPasswordComponent_input_1_Template, 1, 5, "input", 1);
        ɵngcc0.ɵɵtemplate(2, InputPasswordComponent_input_2_Template, 1, 5, "input", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵlistener("click", function InputPasswordComponent_Template_span_click_3_listener() { return ctx.showOrHide(); });
        ɵngcc0.ɵɵelementStart(4, "button", 4);
        ɵngcc0.ɵɵelement(5, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showPassword);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPassword);
    } }, directives: [ɵngcc2.NgIf, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.FormControlDirective, ɵngcc2.NgStyle, ɵngcc4.MaxLengthValidator], styles: [".password[_ngcontent-%COMP%]{border-bottom:1px solid #7e8282}.icon[_ngcontent-%COMP%], .password[_ngcontent-%COMP%]{color:#f7941d;font-size:24px}.icon[_ngcontent-%COMP%]{cursor:pointer;margin-top:5px}"] });
InputPasswordComponent.propDecorators = {
    control: [{ type: Input }],
    formControlName: [{ type: Input }],
    placeholder: [{ type: Input }],
    maxlength: [{ type: Input }],
    style: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'dharma-input-password',
                template: "<div class=\"input-group\">\n  <input *ngIf=\"!showPassword\"\n  [formControl]=\"control\"\n  type=\"text\"\n  [placeholder]=\"placeholder\"\n  [ngStyle]=\"style\" \n  [maxlength]=\"maxlength\" \n  id=\"{{ formControlName || 'password'}}\"  type=\"password\" class=\"password form-control pwd\">\n  <input *ngIf=\"showPassword\"\n  [formControl]=\"control\"\n  type=\"password\"\n  [placeholder]=\"placeholder\"\n  [ngStyle]=\"style\" \n  [maxlength]=\"maxlength\" \n  id=\"{{ formControlName || 'password'}}\"  type=\"text\" class=\"password form-control pwd\">\n  <span class=\"input-group-btn\" (click)=\"showOrHide()\">\n    <button class=\"btn btn-default reveal\" type=\"button\"><i class=\"icon fa fa-eye\"></i>\n    </button>\n  </span>          \n</div>",
                styles: [".password{border-bottom:1px solid #7e8282}.icon,.password{color:#f7941d;font-size:24px}.icon{cursor:pointer;margin-top:5px}"]
            }]
    }], function () { return []; }, { placeholder: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], style: [{
            type: Input
        }], control: [{
            type: Input
        }], formControlName: [{
            type: Input
        }] }); })();

class InputPasswordModule {
}
InputPasswordModule.ɵfac = function InputPasswordModule_Factory(t) { return new (t || InputPasswordModule)(); };
InputPasswordModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: InputPasswordModule });
InputPasswordModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ReactiveFormsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InputPasswordModule, { declarations: function () { return [InputPasswordComponent]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule]; }, exports: function () { return [InputPasswordComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputPasswordModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                ],
                declarations: [InputPasswordComponent],
                exports: [InputPasswordComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CountdownTimerComponent, CountdownTimerModule, FileUploadComponent, FileUploadModule, FileUploadService, InputPasswordComponent, InputPasswordModule, LoaderComponent, LoaderModule, LoaderService, ModalComponent, ModalModule, NgxDropzoneComponent, NgxDropzoneLabelDirective, NgxDropzoneModule, NgxDropzonePreviewComponent, NgxDropzoneService as ɵa, NgxDropzoneImagePreviewComponent as ɵb, NgxDropzoneRemoveBadgeComponent as ɵc, NgxDropzoneVideoPreviewComponent as ɵd };

//# sourceMappingURL=dharma-ui-components.js.map